import React from 'react';

import { cssMap } from '@atlaskit/css';
import { DropIndicator } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/box';
import { Box } from '@atlaskit/primitives/compiled';

export const CURSOR_DROP_INDICATOR_OFFSET = '--editor-cursor-drop-indicator-offset';
export const CURSOR_DROP_INDICATOR_GAP = '--editor-cursor-drop-indicator-gap';
/** CSS variable for content width (px) – set by decoration from api.width.sharedState.currentState().lineLength */
export const CURSOR_DROP_INDICATOR_WIDTH = '--editor-cursor-drop-indicator-width';

const DEFAULT_DROP_INDICATOR_WIDTH_PX = '760px';

const styles = cssMap({
	container: {
		position: 'absolute',
		left: 0,
		display: 'block',
		zIndex: 100,
		transform: `translateY(var(${CURSOR_DROP_INDICATOR_OFFSET}, 0))`,
		width: '100%',
	},
	dropIndicator: {
		height: '100%',
		margin: '0 auto',
		position: 'relative',
		display: 'block',
	},
});

/**
 * Visual line only – no drop handling. Drop is handled by EditorDropTarget in hub-home.
 * Width matches editor content via CSS variable set by the decoration (from width plugin state).
 */
export function CursorDropIndicator(): React.JSX.Element {
	return (
		<Box xcss={styles.container} testId="hub-external-insert-cursor-drop-indicator">
			<Box
				xcss={styles.dropIndicator}
				style={{ width: `var(${CURSOR_DROP_INDICATOR_WIDTH}, ${DEFAULT_DROP_INDICATOR_WIDTH_PX})` }}
				testId="hub-external-insert-cursor-drop-indicator-box"
			>
				<DropIndicator edge="bottom" />
			</Box>
		</Box>
	);
}

